import React, {  } from "react";
import Landingimg from "../../src/assets/images/design-system.png";
const Landingpage = () => {
  return (
    <div className="landingpage">
      <section className="hero-section-wrapper">
        <div className="hero-content">
          <h1>Design, develop, deliver</h1>
          <p>
            Use Freya Fusion's end-to-end design language to create simple,
            intuitive and beautiful experiences.
          </p>
          <a href="/foundations" tabIndex={0}>
            <span className="css-17wby6x">Get started</span>
          </a>
        </div>
        <div className="hero-banner">
          <img
            className="css-1riai7t"
            src={Landingimg}
            height="60rem"
            width="80rem"
            alt=""
          />
        </div>
      </section>
    </div>
  );
};

export default Landingpage;
